





































import Vue from 'vue';
import { mapActions } from 'vuex';
import { nth } from 'lodash';

import StepNavigation, { Step } from '@/components/step_navigation/StepNavigation.vue';

import FooterNavigation from './components/FooterNavigation.vue';
import ScopingListing from './components/ScopingListing.vue';
import ScopingMapperWrapper from './components/ScopingMapperWrapper.vue';
import Sidebar from './components/Sidebar.vue';

const STEP_OBJECTS = ['standards', 'sections', 'objectives', 'controls'];

export default Vue.extend({
  name: 'PSSOScopingPage',
  components: {
    FooterNavigation,
    ScopingListing,
    ScopingMapperWrapper,
    Sidebar,
    StepNavigation,
  },
  props: {
    programId: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
      validator: (val: string) => STEP_OBJECTS.includes(val),
    },
  },
  data() {
    return {
      selectedParent: null,
    };
  },
  computed: {
    currentStep() {
      return STEP_OBJECTS.indexOf(this.objectType) + 1;
    },
    steps(): Step[] {
      return STEP_OBJECTS.map((objectName, index) => ({
        id: index + 1,
        title: objectName,
        done: index < this.currentStep,
        disabled: false,
      }));
    },
    parentObjectType(): String {
      const currentIndex = STEP_OBJECTS.indexOf(this.objectType);
      if (currentIndex === 0) {
        return 'programs';
      }

      return nth(STEP_OBJECTS, currentIndex - 1);
    },
  },
  created() {
    this.setPageTitle({ title: 'Program Scoping' });
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
    selectParent(item) {
      this.selectedParent = item;
    },
    moveStep(offset: number) {
      this.setStep(this.currentStep + offset);
    },
    setStep(newStep: number) {
      if (newStep > STEP_OBJECTS.length) {
        // Going beyond last step means we should finish and redirect back to
        // program scoping
        this.$router.push({ name: 'programScoping' });
      } else {
        this.selectedParent = null;
        this.$router.push({
          name: 'programScopingPSSOScoping',
          params: { programId: this.programId, objectType: STEP_OBJECTS[newStep - 1] },
        });
      }
    },
  },
});
